// extracted by mini-css-extract-plugin
module.exports = {"root":"_35JhHcVJMvGp","body":"_30h2FWJbCSs5","logo_wrapper":"_2oL8IumMKO0S","menu_wrapper":"BFrF0X3DShrO"};